import PropTypes from "prop-types";
// form
import { FormProvider as Form } from "react-hook-form";

FormProvider.propTypes = {
  children: PropTypes.node.isRequired,
  methods: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
};

export default function FormProvider({ children, onSubmit, methods, showSaveBar = undefined }) {
  const handleReset = () => {
    methods.reset();
  };

  return (
    <Form {...methods}>
      <form data-save-bar={showSaveBar || undefined} onSubmit={onSubmit} onReset={handleReset} noValidate>
        {children}
      </form>
    </Form>
  );
}
